import { useMemo } from "react";
import Radio from "@mui/material/Radio";
import Typography from "@mui/material/Typography";
import { useStyles } from "./styles";
import SmsIcon from "../../assets/campaign/sms.png";
import WhatsAppIcon from "../../assets/campaign/whatsapp.png";
import EmailIcon from "../../assets/campaign/email.png";
import { LIGHT_BLACK } from "../../utils/colors";
import { OptionChannel } from "../../types/campaign";

type ChannelProps = {
  title: string;
  subtitle?: string;
  icon?: OptionChannel;
  value?: any;
  disabled?: boolean;
};

export const Channel = ({
  title,
  subtitle,
  icon,
  value,
  disabled,
}: ChannelProps) => {
  const styles = useStyles();

  const iconImg = useMemo(() => {
    switch (icon) {
      case "sms":
        return SmsIcon;
      case "whatsapp":
        return WhatsAppIcon;
      case "email":
        return EmailIcon;
      default:
        return SmsIcon;
    }
  }, [icon]);

  return (
    <div className={styles.root}>
      {icon && <img className={styles.imgIcon} src={iconImg} alt="sms-icon" />}
      <div className={styles.rootContent}>
        <Typography fontWeight={600} color={LIGHT_BLACK} marginBottom={1}>
          {title}
        </Typography>
        {subtitle && (
          <Typography variant="body2" color={LIGHT_BLACK}>
            {subtitle}
          </Typography>
        )}
      </div>
      <Radio value={value} disabled={disabled} />
    </div>
  );
};
